module.exports = __webpack_public_path__ + "static/media/4.bbf5b8bc.JPG";